import { TYPE_BOOLEAN } from './input-types';

export const id = 'is-domestic';
export const apiKey = 'ShipToIsDomestic';
export const type = TYPE_BOOLEAN;

export const isDomestic = {
  id,
  apiKey,
  type,
};
